module.exports = __webpack_public_path__ + "static/IMG_1529-b661ebbd268233f132b0c74c3548b560.jpg";